"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenedDialogsProvider = exports.useOpenedDialogContext = void 0;
var React = require("react");
var dialogs_reducer_1 = require("./dialogs-reducer");
var openedDialogsDefaults = {
    openedDialogs: [],
    dialogDispatch: function () { },
};
var OpenedDialogContext = React.createContext(openedDialogsDefaults);
var useOpenedDialogContext = function () { return React.useContext(OpenedDialogContext); };
exports.useOpenedDialogContext = useOpenedDialogContext;
var OpenedDialogsProvider = function (_a) {
    var children = _a.children;
    var _b = __read(React.useReducer(dialogs_reducer_1.dialogReducer, []), 2), openedDialogs = _b[0], dialogDispatch = _b[1];
    return (React.createElement(OpenedDialogContext.Provider, { value: { openedDialogs: openedDialogs, dialogDispatch: dialogDispatch } }, children));
};
exports.OpenedDialogsProvider = OpenedDialogsProvider;
//# sourceMappingURL=opened-dialogs-provider.js.map